import {
  createContext,
  Dispatch,
  useContext,
  useEffect,
  useReducer,
} from "react";
import {
  AddPolicySubjectActions,
  // AddPolicySubjectData,
  AddPolicySubjectReducer,
  initialAddPolicySubjectState,
} from "./AddPolicySubjectReducer";
import { ApiInteractingStatusType } from "../../../../types/common.types";
import { ReadOnlyClaim } from "../../../../redux/apiSpecifications/apiClaims";
import { Subject } from "../../../../redux/apiSpecifications/apiSubjects";

export type NewPolicySubjectRoleType = "C" | "P" | "C&P";

export interface AddPolicySubjectContextData {
  claim: ReadOnlyClaim;
  policySubjectRole?: NewPolicySubjectRoleType;
  addPolicySubjectData?: Subject;
  // openWizard: boolean;
  apiInteractingStatus: ApiInteractingStatusType | undefined;
  // allBranches: Branch[];
  // onCreateClaim: (createClaimData: CreateClaimData, complete: boolean) => void;
}

const AddPolicySubjectContext = createContext<
  AddPolicySubjectContextData | undefined
>(undefined);

const AddPolicySubjectDispatchContext = createContext<
  Dispatch<AddPolicySubjectActions> | undefined
>(undefined);

interface IAddPolicySubjectProviderProps {
  claim: ReadOnlyClaim;
  policySubjectRole?: NewPolicySubjectRoleType;
  children: React.ReactNode;
}

const AddPolicySubjectProvider: React.FC<IAddPolicySubjectProviderProps> = ({
  claim,
  policySubjectRole,
  children,
}) => {
  const [state, dispatch] = useReducer(
    AddPolicySubjectReducer,
    initialAddPolicySubjectState
  );

  useEffect(() => {
    if (policySubjectRole) {
      dispatch!({ type: "INIT_STATE" });
    }
  }, [policySubjectRole]);

  return (
    <AddPolicySubjectContext.Provider
      value={{
        claim: claim,
        policySubjectRole: policySubjectRole,
        addPolicySubjectData: state.addPolicySubjectData,
        // openWizard: state.openWizard,
        apiInteractingStatus: state.apiInteractingStatus,
        // allBranches: state.allBranches,
        // onCreateClaim: onCreateClaim
        // selectionPolicyStep: state.selectionPolicyStep
      }}
    >
      <AddPolicySubjectDispatchContext.Provider value={dispatch}>
        {children}
      </AddPolicySubjectDispatchContext.Provider>
    </AddPolicySubjectContext.Provider>
  );
};

export const useAddPolicySubjectContext = (): AddPolicySubjectContextData => {
  const context = useContext(AddPolicySubjectContext);

  if (!context) {
    throw new Error("Errore");
  }

  return context;
};

export function useAddPolicySubjectDispatch() {
  const context = useContext(AddPolicySubjectDispatchContext);

  if (!context) {
    throw new Error("Errore");
  }

  return context;
}

export default AddPolicySubjectProvider;
